<template>
  <div class="slider">
    <swiper ref="swiper" :options="options">
      <swiper-slide v-for="(slide, i) in sliderList" :key="i">
        <img :src="file(slide.ImageLink)" style="width: 100%" :alt="'slider_' + i" />
        <div class="text-slide bottom-left" v-if="slide.Link">
          <a :href="slide.Link">{{ slide.LinkText }}</a>
        </div>
      </swiper-slide>
    </swiper>
    <i class="slide-nav prev diginity dg-left-arrow-thin" id="slide-nav__prev"></i>
    <i class="slide-nav next diginity dg-right-arrow-thin" id="slide-nav__next"></i>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      options: {
        slidesPerView: 1,
        speed: 1000,
        loop: true,
        autoplay: {
          delay: 5000,
        },
        preloadImages: false,
        updateOnImagesReady: false,
        on: {
          init: function () {
            this.autoplay.stop();
            // resimlerin yüklenmesini takip etmek için updateOnImagesReady özelliği kullanılır
            this.params.updateOnImagesReady = true;
            // resimleri önceden yüklemek için preloadImages özelliği kullanılır
            this.preloadImages();
          },
          imagesReady: function () {
            // resimler tamamen yüklendikten sonra autoplay başlatılır
            this.autoplay.start();
          },
        },
        navigation: {
          nextEl: "#slide-nav__next",
          prevEl: "#slide-nav__prev",
        },
      },
      components: {
        swiper,
        swiperSlide,
      },
    };
  },
  computed: {
    ...mapGetters(["file", "sliderList"]),
  },
  components: {
    swiper,
    swiperSlide,
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/colors";
.slider {
  min-height: 100px;
  position: relative;
  font-size: 0;
  .swiper-slide {
    position: relative;
    .text-slide {
      position: absolute;
      z-index: 500;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      justify-content: flex-start;
      align-items: flex-end;
      @media screen and (max-width: 480px) {
        padding: 10px;
        a {
          font-size: 8px;
        }
      }
      a {
        padding: 7px;
        border-radius: 2px;
        font-size: 13px;
        line-height: 14px;
        background: rgba($mainLight, 0.8);
        color: #fff;
        &:hover {
          background: rgba($mainLight, 0.85);
        }
        @media screen and (max-width: 480px) {
          font-size: 10px;
          padding: 3px;
          line-height: 10px;
        }
      }
    }
  }
  i.slide-nav {
    outline: none;
    color: $main;
    position: absolute;
    top: calc(50% - 25px);
    font-size: 25px;
    padding: 5px;
    border-radius: 1px;
    z-index: 5;
    background: rgba(255, 255, 255, 0.5);
    @media screen and (max-width: 480px) {
      top: calc(50% - 15px);
      font-size: 15px;
    }
    cursor: pointer;
    &:hover {
      color: $mainLight;
    }
    &.next {
      right: 0;
    }
    &.prev {
      left: 0;
    }
    /* disabled */
    &.swiper-button-disabled {
      display: none;
    }
  }
}
</style>
